import { routes } from 'constants/routes'

import NoMatch from 'pages/NoMatch/NoMatch'
import { useEffect, useState  } from 'react'
import { Route, Routes, useNavigate, useLocation } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { setUser } from 'store/slices/UserSlice'
import ApiStatusModal from 'components/ApiStatusModal'
import { setApiStatusHandler } from 'http/apiJSON'

console.log = console.warn = console.error = () => {};

console.info = () => {};
function App() {
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()
  const [authChecked, setAuthChecked] = useState(false)
  const [apiUnavailable, setApiUnavailable] = useState(false)

  // Устанавливаем обработчик статуса API
  useEffect(() => {
    setApiStatusHandler(setApiUnavailable);
  }, []);

  const handleContextMenu = (event) => {
    event.preventDefault();
  };

  const handleKeyDown  = (event) => {
    if (event.key === 'F12') { 
      event.preventDefault();
    }
    if (event.ctrlKey && event.shiftKey) {
      
      switch (event.key) {
          case 'C':
          case 'c':
          case 'С':
          case 'с':
              event.preventDefault();
              break;
          case 'Ш':
          case 'ш':
              event.preventDefault();
              break;
          case 'I':
          case 'i':
              event.preventDefault();
              break;
          default:
              break;
      }
  }
  
  if (event.ctrlKey && event.altKey) {
      switch (event.key) {
          case 'C':
          case 'c':
          case 'С':
          case 'с':
              event.preventDefault();
              break;
          case 'I':
          case 'i':
          case 'Ш':
          case 'ш':
              event.preventDefault();
              break;
          default:
              break;
      }
  }
  if (event.ctrlKey) {
      switch (event.key) {
        case 'U':
        case 'u':
        case 'г':
        case 'Г':
            event.preventDefault();
            break;
        default:
            break;
    }
  }
  if (event.metaKey  && event.altKey) {
    switch (event.key) {
      case 'U':
      case 'u':
      case 'г':
      case 'Г':
          event.preventDefault();
          break;
      default:
          break;
  }
}
  }

  // Проверка авторизации при загрузке приложения
  useEffect(() => {
    const token = localStorage.getItem('token')
    const userDataStr = localStorage.getItem('user')
    const rememberMe = localStorage.getItem('rememberMe')

    // Если есть токен, данные пользователя и флаг "запомнить"
    if (token && userDataStr && rememberMe === 'true') {
      try {
        const userData = JSON.parse(userDataStr)
        // Восстанавливаем данные в Redux
        dispatch(setUser(userData))
        
        // Если находимся на странице логина
        if (location.pathname === '/') {
          if (userData?.is_personal_kyrgyzkomur) {
             navigate('/employee-card/', { replace: true })
          } else {
             navigate('/report-card/', { replace: true })
          }
        }
      } catch (error) {
        console.warn('Ошибка восстановления сессии:', error)
      }
    }
    
    setAuthChecked(true)
  }, [])

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  // Не рендерим роуты пока не проверили авторизацию
  if (!authChecked) {
    return null
  }
 

  return (
    <div className="app" onContextMenu={handleContextMenu}>
      <ApiStatusModal isVisible={apiUnavailable} />
      <Routes>
        {routes.map((route) => {
          return (
            <Route
              key={route.path}
              path={route.path}
              element={route.component}
            />
          )
        })}
       
        <Route path="*" element={<NoMatch />} />
      </Routes>

    
     
    </div>
  )
}

export default App
